import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditCodigoPromocionalComponent } from "./edit-codigo-promocional/edit-codigo-promocional.component";

@Component({
  selector: "app-codigo-promocional",
  templateUrl: "./codigo-promocional.component.html",
  styleUrls: ["./codigo-promocional.component.scss"],
})
export class CodigoPromocionalComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditCodigoPromocionalComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
